import {splitCode} from "@feature/kcolor/utils/utils";
const ColorCollectionItem = ({
  code,
  rgb,
  className = "",
  isUnfocused = false,
  isDisabled = false,
  onClick = () => {},
}) => {

  // utils
  const aspect = {w: 16, h: 9};  // Aspect ratio 16:9
  const getContrastColor = (rgb) => {
    // This function guarantees that the text is readable against the background color
    const [r, g, b] = rgb;
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? "black" : "white";
  };


  return (
    <div id={code} className={[
      "flex flex-col select-none",
      isDisabled || isUnfocused ? "opacity-50" : "",
      isDisabled ? "cursor-not-allowed" : `cursor-pointer ${isUnfocused ? "hover:opacity-100" : "hover:opacity-80"}`,
      className,
    ].join(" ")}>
      <div
        className="w-full relative rounded"
        style={{
          aspectRatio: `${aspect.w} / ${aspect.h}`,
          backgroundColor: `rgb(${rgb.join(", ")})`,
        }}
        onClick={() => {
          if (isDisabled) return;
          onClick(code);
        }}
      >
        {isDisabled && (
          <svg viewBox={`0 0 ${aspect.w} ${aspect.h}`} className="w-full h-full absolute inset-0">
            <line x1="0" y1="0" x2={aspect.w} y2={aspect.h} stroke="#0008" strokeWidth="0.25"/>
            <line x1={aspect.w} y1="0" x2="0" y2={aspect.h} stroke="#0008" strokeWidth="0.25"/>
          </svg>
        )}
        <div className="flex items-end p-1.5 absolute inset-0">
          <p
            className={`leading-none ${isDisabled ? "line-through" : ""}`}
            style={{fontWeight: !isDisabled ? 600 : 400, fontSize: "0.7rem", color: getContrastColor(rgb)}}
          >
            {splitCode(code)}
          </p>
        </div>
      </div>
    </div>
  );
}

export default ColorCollectionItem;
